export default {
  body: 1.5,
  heading: 1.15,
}
